import get from 'lodash.get'

const getDefaultState = () => ({
  authenticated: false,
  authenticationPromise: null,
  credentials: localStorage.credentials ? JSON.parse(localStorage.credentials) : '',
  customer: '',
  error: null,
  initialized: false
})

const state = getDefaultState()

const mutations = {
  init (state) {
    if (localStorage.credentials) {
      state.credentials = JSON.parse(localStorage.credentials)
    }
    state.initialized = true
  },
  setCredentials (state, value) {
    state.credentials = value
    if (state.credentials) {
      state.credentials.userAgent = navigator.userAgent
    }
    // setting null to localstorage will give us back 'null' when reading it
    localStorage.credentials = state.credentials === null ? '' : JSON.stringify(state.credentials)
  },
  setCustomer (state, customer) {
    state.customer = customer
  },
  setAuthenticated (state, value) {
    state.authenticated = value
    if (value) {
      state.error = null
    }
  },
  setAuthenticationError (state, error) {
    state.error = error
  },
  setAuthenticationPromise (state, promise) {
    state.authenticationPromise = promise
  }
}

const actions = {
  async authenticate ({ state, commit, dispatch, rootState }) {
    if (!state.initialized) {
      commit('init')
    }
    const authPromise = dispatch('orderFormService/authenticate', state.credentials, { root: true })
    commit('setAuthenticationPromise', authPromise)
    const ok = await authPromise
    const token = ok ? rootState.orderFormService.latestRequests.authenticate.response.authToken : ''
    commit('setAuthenticationPromise', null)
    if (ok) {
      const customerData = rootState.orderFormService.latestRequests.authenticate.response.customer
      commit('setCustomer', customerData)
    }
    return dispatch('updateAuthentication', {
      token: token,
      authenticated: ok
    })
  },
  async checkAuthentication ({ state, dispatch, getters }) {
    if (!state.authenticated && getters.hasCredentials) {
      await dispatch('authenticate')
    }
  },
  async logout ({ commit, dispatch }) {
    // TODO: send logout to backend once available
    commit('ui/reset', null, { root: true })
    dispatch('ui/showStartPage', null, { root: true })
    return dispatch('updateAuthentication', {
      token: '',
      authenticated: false
    })
  },
  async resetPassword ({ dispatch }, { email }) {
    return dispatch('orderFormService/requestNewPasswordToken', {
      emailAddress: email
    }, { root: true })
  },
  async setNewPassword ({ state, dispatch }, { token, password }) {
    // ignore the token if we are only setting the new password
    return dispatch('orderFormService/saveNewPassword', {
      newPasswordToken: state.authenticated ? '' : token,
      newPassword: password
    }, { root: true })
  },
  async updateAuthentication ({ state, commit, dispatch }, { token, authenticated }) {
    commit('setCredentials', {
      authToken: token
    })
    commit('setAuthenticated', authenticated)
    return authenticated
  }
}

const getters = {
  authenticating (state) {
    return state.authenticationPromise !== null
  },
  customer (state, getters, rootState) {
    return get(rootState, 'orderFormService.latestRequests.authenticate.response.customer')
  },
  hasCredentials (state) {
    return state.credentials !== null && state.credentials !== '' &&
    (
      (state.credentials.authToken !== undefined && state.credentials.authToken !== '') || false
      // (state.credentials.email !== undefined && state.credentials.password !== undefined && state.credentials.email !== '' && state.credentials.password !== '')
    )
  },
  // these parameters are expected by the generic service
  // for example, if authentication changes, the service could reset it's state
  serviceParams (state) {
    return {
      // take as-is
      authenticated: state.authenticated,
      // which parameter gets set to add credentials on request and it's value
      authenticationMethod: state.credentials
    }
  }
}
export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
